document.addEventListener('DOMContentLoaded', () => {
  const customizers = document.querySelectorAll('.peralta-customizer');

  customizers.forEach((customizer) => {
    const tools = customizer.querySelectorAll('.customizer-tool');
    const panels = customizer.querySelectorAll('.customizer-panel');

    tools.forEach((tool) => {
      tool.addEventListener('click', () => {
        const targetPanel = tool.dataset.panel;

        tools.forEach((item) => {
          item.classList.remove('customizer-tool--active');
        });

        panels.forEach((panel) => {
          panel.classList.remove('customizer-panel--active');
        });

        tool.classList.add('customizer-tool--active');

        const activePanel = customizer.querySelector(
          `[data-panel-content="${targetPanel}"]`
        );

        if (activePanel) {
          activePanel.classList.add('customizer-panel--active');
        }
      });
    });
  });
});

document.querySelectorAll('.peralta-customizer').forEach((customizer) => {
  const productImage = customizer.querySelector('.customizer-product__image');

const productPlaceholder = customizer.querySelector(
  '.customizer-product__placeholder'
);

const placeholderName = customizer.querySelector(
  '[id^="CustomizerProductPlaceholderName-"]'
);

const viewButtons = customizer.querySelectorAll('.customizer-view');

const statusText = customizer.querySelector('.customizer-status');

const undoButton = customizer.querySelector('[data-customizer-undo]');
const redoButton = customizer.querySelector('[data-customizer-redo]');

const undoStack = [];
const redoStack = [];

const updateHistoryButtons = () => {
  if (undoButton) {
    undoButton.disabled = undoStack.length === 0;
  }

  if (redoButton) {
    redoButton.disabled = redoStack.length === 0;
  }
};

if (undoButton) {
  undoButton.addEventListener('click', () => {
    if (undoStack.length === 0) return;

    const currentState =
      cloneViewState(getCurrentViewState());

    const previousState =
      undoStack.pop();

    redoStack.push(currentState);

    applyHistoryState(previousState);
    updateHistoryButtons();
  });
}

if (redoButton) {
  redoButton.addEventListener('click', () => {
    if (redoStack.length === 0) return;

    const currentState =
      cloneViewState(getCurrentViewState());

    const nextState =
      redoStack.pop();

    undoStack.push(currentState);

    applyHistoryState(nextState);
    updateHistoryButtons();
  });
}
const layersPanel = customizer.querySelector(
  '[data-customizer-layers]'
);

const layersEmptyMessage = customizer.querySelector(
  '.customizer-layers__empty'
);
const uploadInput = customizer.querySelector(
  'input[id^="CustomizerImageUpload-"]'
);

const designCanvas = customizer.querySelector(
  'canvas[id^="CustomizerCanvas-"]'
);

const designContext = designCanvas
  ? designCanvas.getContext('2d')
  : null;

const createViewState = () => ({
  layers: [],
  selectedLayerId: null
});

const uploadedDesigns = {
  camiseta: {
    front: createViewState(),
    back: createViewState()
  },
  polo: {
    front: createViewState(),
    back: createViewState()
  },
  sudadera: {
    front: createViewState(),
    back: createViewState()
  },
  bolsa: {
    front: createViewState(),
    back: createViewState()
  }
};

let currentProductType = 'Camiseta';

let currentView = 'front';

const normalizeProductKey = (productType) => {
  const map = {
    Camiseta: 'camiseta',
    Polo: 'polo',
    Sudadera: 'sudadera',
    Bolsa: 'bolsa'
  };

  return map[productType] || 'camiseta';
};

const createDesignState = (image) => {
  const canvasWidth = designCanvas.width;
  const canvasHeight = designCanvas.height;

  const maxWidth = canvasWidth * 0.32;
  const maxHeight = canvasHeight * 0.32;

  const scale = Math.min(
    maxWidth / image.width,
    maxHeight / image.height
  );

  const width = image.width * scale;
  const height = image.height * scale;

  return {
  id: `layer-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  type: 'image',
  visible: true,
  image,
  width,
  height,
  x: (canvasWidth - width) / 2,
  y: canvasHeight * 0.30,
  rotation: 0
};
};

const getCurrentViewState = () => {
  const productKey = normalizeProductKey(currentProductType);

  return uploadedDesigns[productKey]?.[currentView] || null;
};

const getCurrentDesign = () => {
  const viewState = getCurrentViewState();

  if (!viewState) return null;

  if (viewState.selectedLayerId) {
    const selectedLayer = viewState.layers.find(
      (layer) => layer.id === viewState.selectedLayerId
    );

    if (selectedLayer) {
      return selectedLayer;
    }
  }

  return null;
};

const cloneDesignState = (design) => {
  if (!design) return null;

  return {
    ...design
  };
};

const cloneViewState = (viewState) => {
  if (!viewState) return null;

  return {
    layers: viewState.layers.map((layer) =>
      cloneDesignState(layer)
    ),
    selectedLayerId: viewState.selectedLayerId
  };
};

const saveHistoryState = () => {
  const viewState = getCurrentViewState();

  undoStack.push(
    cloneViewState(viewState)
  );

  redoStack.length = 0;

  updateHistoryButtons();
};

const applyHistoryState = (state) => {
  const productKey =
    normalizeProductKey(currentProductType);

  uploadedDesigns[productKey][currentView] =
    state
      ? cloneViewState(state)
      : createViewState();

  renderDesign();
};

const trimTransparentImage = (image) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  canvas.width = image.naturalWidth || image.width;
  canvas.height = image.naturalHeight || image.height;

  context.drawImage(image, 0, 0);

  const imageData = context.getImageData(
    0,
    0,
    canvas.width,
    canvas.height
  );

  const { data, width, height } = imageData;

  let minX = width;
  let minY = height;
  let maxX = -1;
  let maxY = -1;

  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const alpha = data[(y * width + x) * 4 + 3];

      if (alpha > 10) {
        minX = Math.min(minX, x);
        minY = Math.min(minY, y);
        maxX = Math.max(maxX, x);
        maxY = Math.max(maxY, y);
      }
    }
  }

  // Si no encontramos transparencia útil, usamos la imagen original
  if (maxX === -1 || maxY === -1) {
    return image;
  }

  const padding = 4;

  minX = Math.max(0, minX - padding);
  minY = Math.max(0, minY - padding);
  maxX = Math.min(width - 1, maxX + padding);
  maxY = Math.min(height - 1, maxY + padding);

  const cropWidth = maxX - minX + 1;
  const cropHeight = maxY - minY + 1;

  const croppedCanvas = document.createElement('canvas');

  croppedCanvas.width = cropWidth;
  croppedCanvas.height = cropHeight;

  const croppedContext = croppedCanvas.getContext('2d');

  croppedContext.drawImage(
    canvas,
    minX,
    minY,
    cropWidth,
    cropHeight,
    0,
    0,
    cropWidth,
    cropHeight
  );

  return croppedCanvas;
};

const renderLayersPanel = () => {
  if (!layersPanel) return;

  const viewState = getCurrentViewState();

  if (!viewState) return;

  const layers = viewState.layers;

  /* Limpiamos la maqueta anterior */
  layersPanel.innerHTML = '';

  /* ESTADO VACÍO */
  if (layers.length === 0) {
    if (layersEmptyMessage) {
      layersEmptyMessage.hidden = false;
    }

    return;
  }

  if (layersEmptyMessage) {
    layersEmptyMessage.hidden = true;
  }

  /*
   * Mostramos primero la capa superior.
   * En el canvas, la última del array es la que
   * se dibuja encima.
   */
  [...layers]
    .reverse()
    .forEach((layer, reverseIndex) => {
      const realIndex =
        layers.length - 1 - reverseIndex;

      const item = document.createElement('div');

      item.className = 'customizer-layer-item';

      if (layer.id === viewState.selectedLayerId) {
        item.classList.add(
          'customizer-layer-item--selected'
        );
      }

      item.dataset.layerId = layer.id;

      /* MINIATURA */
      const thumb =
        document.createElement('div');

      thumb.className =
        'customizer-layer-item__thumb';

      if (
        layer.type === 'image' &&
        layer.image
      ) {
        const preview =
          document.createElement('img');

        if (
          layer.image instanceof HTMLCanvasElement
        ) {
          preview.src =
            layer.image.toDataURL('image/png');
        } else {
          preview.src = layer.image.src;
        }

        preview.alt = '';
        preview.draggable = false;

        thumb.appendChild(preview);
      }

      /* INFORMACIÓN */
      const info =
        document.createElement('div');

      info.className =
        'customizer-layer-item__info';

      const title =
        document.createElement('strong');

      title.textContent =
        layer.name ||
        `Diseño ${realIndex + 1}`;

      const type =
        document.createElement('span');

      type.textContent =
        layer.type === 'image'
          ? 'Imagen'
          : 'Elemento';

      info.appendChild(title);
      info.appendChild(type);

      /* ACCIONES - todavía solo visuales */
      const actions =
        document.createElement('div');

      actions.className =
        'customizer-layer-item__actions';

      actions.innerHTML = `
  <button
    type="button"
    title="Mostrar u ocultar"
    data-layer-visibility
    aria-label="Mostrar u ocultar capa"
  >
    <svg
      viewBox="0 0 24 24"
      width="16"
      height="16"
      aria-hidden="true"
    >
      <path
        d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="12"
        cy="12"
        r="2.6"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
      />
    </svg>
  </button>

  <button
    type="button"
    title="Bloquear capa"
    data-layer-lock
    aria-label="Bloquear capa"
  >
    <svg
      viewBox="0 0 24 24"
      width="16"
      height="16"
      aria-hidden="true"
    >
      <rect
        x="5"
        y="10"
        width="14"
        height="10"
        rx="2"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
      />
      <path
        d="M8 10V7a4 4 0 0 1 8 0v3"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
      />
    </svg>
  </button>

  <button
    type="button"
    title="Eliminar capa"
    data-layer-delete
    aria-label="Eliminar capa"
  >
    <svg
      viewBox="0 0 24 24"
      width="16"
      height="16"
      aria-hidden="true"
    >
      <path
        d="M4 7h16"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
      />
      <path
        d="M9 7V4h6v3"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 7l1 13h8l1-13"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
`;
const visibilityButton =
  actions.querySelector('[data-layer-visibility]');

if (visibilityButton) {
  visibilityButton.addEventListener('click', (event) => {
    event.stopPropagation();

    saveHistoryState();

    layer.visible =
      layer.visible === false
        ? true
        : false;

    if (layer.visible === false) {
      if (viewState.selectedLayerId === layer.id) {
        viewState.selectedLayerId = null;
      }
    }

    renderLayersPanel();
    renderDesign();
  });
}

      item.appendChild(thumb);
      item.appendChild(info);
      item.appendChild(actions);

      /* CLIC EN LA FILA = SELECCIONAR CAPA */
item.addEventListener('click', (event) => {
  if (event.target.closest('button')) return;

  const currentViewState = getCurrentViewState();

  if (!currentViewState) return;

  currentViewState.selectedLayerId = layer.id;

  renderLayersPanel();
  renderDesign();
});

      layersPanel.appendChild(item);
    });
};

const renderDesign = () => {
  if (!designCanvas || !designContext) return;

  designContext.clearRect(
    0,
    0,
    designCanvas.width,
    designCanvas.height
  );

  const viewState = getCurrentViewState();

if (!viewState) return;

const layers = viewState.layers;

if (layers.length === 0) return;

const design = getCurrentDesign();

const printArea = getPrintArea();

  /* =========================================
   AVISO: DISEÑO FUERA DEL ÁREA DE IMPRESIÓN
   Solo comprobamos la capa seleccionada
   ========================================= */

let isDesignOutsidePrintArea = false;

if (design) {
  const warningCenterX =
    design.x + design.width / 2;

  const warningCenterY =
    design.y + design.height / 2;

  const warningAngle =
    ((design.rotation || 0) * Math.PI) / 180;

  const warningCos = Math.cos(warningAngle);
  const warningSin = Math.sin(warningAngle);

  const warningHalfWidth =
    design.width / 2;

  const warningHalfHeight =
    design.height / 2;

  const warningCorners = [
    [-warningHalfWidth, -warningHalfHeight],
    [ warningHalfWidth, -warningHalfHeight],
    [ warningHalfWidth,  warningHalfHeight],
    [-warningHalfWidth,  warningHalfHeight]
  ].map(([x, y]) => ({
    x:
      warningCenterX +
      x * warningCos -
      y * warningSin,

    y:
      warningCenterY +
      x * warningSin +
      y * warningCos
  }));

  isDesignOutsidePrintArea =
    warningCorners.some((corner) =>
      corner.x < printArea.x ||
      corner.x > printArea.x + printArea.width ||
      corner.y < printArea.y ||
      corner.y > printArea.y + printArea.height
    );
}

designContext.save();

designContext.strokeStyle =
  isDesignOutsidePrintArea
    ? 'rgba(220, 38, 38, 0.85)'
    : 'rgba(145, 144, 144, 0.55)';
designContext.lineWidth = 2;
designContext.setLineDash([8, 6]);

designContext.strokeRect(
  printArea.x,
  printArea.y,
  printArea.width,
  printArea.height
);

designContext.restore();

  /* =========================================
   DIBUJAR TODAS LAS CAPAS
   ========================================= */

layers.forEach((layer) => {
  if (
    !layer ||
    layer.visible === false ||
    layer.type !== 'image' ||
    !layer.image
  ) {
    return;
  }

  const layerCenterX =
    layer.x + layer.width / 2;

  const layerCenterY =
    layer.y + layer.height / 2;

  designContext.save();

  /* Recortamos cada capa al área imprimible */
  designContext.beginPath();

  designContext.rect(
    printArea.x,
    printArea.y,
    printArea.width,
    printArea.height
  );

  designContext.clip();

  /* Posición y rotación propias de cada capa */
  designContext.translate(
    layerCenterX,
    layerCenterY
  );

  designContext.rotate(
    ((layer.rotation || 0) * Math.PI) / 180
  );

  designContext.drawImage(
    layer.image,
    -layer.width / 2,
    -layer.height / 2,
    layer.width,
    layer.height
  );

  designContext.restore();
});

/* Si no hay ninguna capa seleccionada,
   dejamos las capas visibles pero no mostramos controles */
if (!design) return;
  designContext.save();

/* =========================================
   CONTROLES DEL DISEÑO ROTADOS
   ========================================= */

const controlCenterX =
  design.x + design.width / 2;

const controlCenterY =
  design.y + design.height / 2;

const controlRotation =
  ((design.rotation || 0) * Math.PI) / 180;

designContext.save();

designContext.translate(
  controlCenterX,
  controlCenterY
);

designContext.rotate(controlRotation);

/* Coordenadas locales del diseño */
const controlX = -design.width / 2;
const controlY = -design.height / 2;


/* MARCO DEL DISEÑO */

designContext.strokeStyle = 'rgba(244, 122, 0, 0.4)';
designContext.lineWidth = 1.2;
designContext.setLineDash([5, 5]);

designContext.strokeRect(
  controlX,
  controlY,
  design.width,
  design.height
);

designContext.setLineDash([]);


/* CONTROL DE ESCALADO - ESQUINA INFERIOR DERECHA */

const scaleHandleSize = 18;

const scaleHandleX =
  controlX + design.width - scaleHandleSize / 2;

const scaleHandleY =
  controlY + design.height - scaleHandleSize / 2;

/* Fondo naranja */
designContext.fillStyle = '#f47a00';

designContext.fillRect(
  scaleHandleX,
  scaleHandleY,
  scaleHandleSize,
  scaleHandleSize
);

/* Símbolo de escalado */
designContext.fillStyle = '#ffffff';
designContext.font = 'bold 14px Arial';
designContext.textAlign = 'center';
designContext.textBaseline = 'middle';

designContext.fillText(
  '↘',
  scaleHandleX + scaleHandleSize / 2,
  scaleHandleY + scaleHandleSize / 2
);

/* =========================================
   CONTROLES DE DEFORMACION
   ========================================= */

/* Puntos discretos para deformar ancho y alto */
const deformHandleSize = 6;

/* CENTRO IZQUIERDO */
const leftHandleX =
  controlX - deformHandleSize / 2;

const leftHandleY =
  controlY + design.height / 2 - deformHandleSize / 2;

/* CENTRO DERECHO */
const rightHandleX =
  controlX + design.width - deformHandleSize / 2;

const rightHandleY =
  controlY + design.height / 2 - deformHandleSize / 2;

/* CENTRO SUPERIOR */
const topHandleX =
  controlX + design.width / 2 - deformHandleSize / 2;

const topHandleY =
  controlY - deformHandleSize / 2;

/* CENTRO INFERIOR */
const bottomHandleX =
  controlX + design.width / 2 - deformHandleSize / 2;

const bottomHandleY =
  controlY + design.height - deformHandleSize / 2;


/* COLOR NARANJA */
designContext.fillStyle = '#f47a00';


/* IZQUIERDA */
designContext.beginPath();
designContext.arc(
  leftHandleX + deformHandleSize / 2,
  leftHandleY + deformHandleSize / 2,
  deformHandleSize / 2,
  0,
  Math.PI * 2
);
designContext.fill();


/* DERECHA */
designContext.beginPath();
designContext.arc(
  rightHandleX + deformHandleSize / 2,
  rightHandleY + deformHandleSize / 2,
  deformHandleSize / 2,
  0,
  Math.PI * 2
);
designContext.fill();


/* ARRIBA */
designContext.beginPath();
designContext.arc(
  topHandleX + deformHandleSize / 2,
  topHandleY + deformHandleSize / 2,
  deformHandleSize / 2,
  0,
  Math.PI * 2
);
designContext.fill();


/* ABAJO */
designContext.beginPath();
designContext.arc(
  bottomHandleX + deformHandleSize / 2,
  bottomHandleY + deformHandleSize / 2,
  deformHandleSize / 2,
  0,
  Math.PI * 2
);
designContext.fill();


/* BOTÓN ELIMINAR */

const deleteSize = 18;

const deleteX =
  controlX - deleteSize / 2;

const deleteY =
  controlY - deleteSize / 2;


/* Fondo rojo */

designContext.fillStyle = '#ef4444';

designContext.fillRect(
  deleteX,
  deleteY,
  deleteSize,
  deleteSize
);


/* X blanca */

designContext.strokeStyle = '#ffffff';
designContext.lineWidth = 2;
designContext.setLineDash([]);

designContext.beginPath();

designContext.moveTo(
  deleteX + 5,
  deleteY + 5
);

designContext.lineTo(
  deleteX + deleteSize - 5,
  deleteY + deleteSize - 5
);

designContext.moveTo(
  deleteX + deleteSize - 5,
  deleteY + 5
);

designContext.lineTo(
  deleteX + 5,
  deleteY + deleteSize - 5
);

designContext.stroke();

/* CONTROL DE ROTACIÓN - ESQUINA SUPERIOR DERECHA */

const rotateHandleSize = 18;

const rotateHandleX =
  controlX + design.width - rotateHandleSize / 2;

const rotateHandleY =
  controlY - rotateHandleSize / 2;

/* Fondo naranja */
designContext.fillStyle = '#f47a00';

designContext.fillRect(
  rotateHandleX,
  rotateHandleY,
  rotateHandleSize,
  rotateHandleSize
);

/* Símbolo de rotación */
designContext.fillStyle = '#ffffff';
designContext.font = 'bold 14px Arial';
designContext.textAlign = 'center';
designContext.textBaseline = 'middle';

designContext.fillText(
  '↻',
  rotateHandleX + rotateHandleSize / 2,
  rotateHandleY + rotateHandleSize / 2 + 1
);

designContext.restore();

};

const updateProductPreview = () => {
  const productKey = normalizeProductKey(currentProductType);

  const imageUrl =
    customizer.dataset[
      `${productKey}${currentView === 'front' ? 'Front' : 'Back'}`
    ];

  if (placeholderName) {
    placeholderName.textContent = currentProductType.toUpperCase();
  }

  if (imageUrl && productImage) {
    productImage.src = imageUrl;
    productImage.hidden = false;

    if (productPlaceholder) {
      productPlaceholder.hidden = true;
    }
  } else {
    if (productImage) {
      productImage.removeAttribute('src');
      productImage.hidden = true;
    }

    if (productPlaceholder) {
      productPlaceholder.hidden = false;
    }
  }

  if (statusText) {
    statusText.textContent =
      currentView === 'front' ? 'Vista frontal' : 'Vista trasera';
  }
  renderDesign();
};
if (uploadInput) {
  uploadInput.addEventListener('change', (event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    const validTypes = [
      'image/png',
      'image/jpeg',
      'image/webp'
    ];

    if (!validTypes.includes(file.type)) {
      alert('Sube una imagen PNG, JPG o WEBP.');
      uploadInput.value = '';
      return;
    }

    const reader = new FileReader();

    reader.onload = (loadEvent) => {
      const image = new Image();

      image.onload = () => {
        const productKey =
          normalizeProductKey(currentProductType);

        const trimmedImage = trimTransparentImage(image);

saveHistoryState();

const viewState = getCurrentViewState();
const newLayer = createDesignState(trimmedImage);

viewState.layers.push(newLayer);
viewState.selectedLayerId = newLayer.id;


renderLayersPanel();
renderDesign();

uploadInput.value = '';
      };

      image.src = loadEvent.target.result;
    };

    reader.readAsDataURL(file);
  });
}
let isDraggingDesign = false;
let isResizingDesign = false;
let isRotatingDesign = false;
let rotationStartAngle = 0;
let rotationStartValue = 0;
let activeDeformHandle = null;

let deformStartWidth = 0;
let deformStartX = 0;
let deformStartHeight = 0;
let deformStartY = 0;
let deformStartCenterX = 0;
let deformStartCenterY = 0;
let deformStartPointerX = 0;
let deformStartPointerY = 0;

let dragOffsetX = 0;
let dragOffsetY = 0;
let resizeStartWidth = 0;
let resizeStartHeight = 0;

let resizeCenterX = 0;
let resizeCenterY = 0;

let resizeStartVectorX = 0;
let resizeStartVectorY = 0;

let resizeStartVectorLengthSquared = 1;

const HANDLE_SIZE = 14;
const MIN_DESIGN_SIZE = 40;
const ROTATION_HANDLE_OFFSET = 28;
const ROTATION_HANDLE_RADIUS = 10;
const getPrintArea = () => {
  return {
    x: designCanvas.width * 0.31,
    y: designCanvas.height * 0.22,
    width: designCanvas.width * 0.38,
    height: designCanvas.height * 0.42
  };
};

const getRotatedBounds = (
  x,
  y,
  width,
  height,
  rotation = 0
) => {
  const angle =
    (rotation * Math.PI) / 180;

  const cos = Math.abs(Math.cos(angle));
  const sin = Math.abs(Math.sin(angle));

  const rotatedWidth =
    width * cos + height * sin;

  const rotatedHeight =
    width * sin + height * cos;

  const centerX = x + width / 2;
  const centerY = y + height / 2;

  return {
    left: centerX - rotatedWidth / 2,
    right: centerX + rotatedWidth / 2,
    top: centerY - rotatedHeight / 2,
    bottom: centerY + rotatedHeight / 2
  };
};


const isDesignInsidePrintArea = (
  x,
  y,
  width,
  height,
  rotation,
  printArea
) => {
  const bounds = getRotatedBounds(
    x,
    y,
    width,
    height,
    rotation
  );

  return (
    bounds.left >= printArea.x &&
    bounds.right <=
      printArea.x + printArea.width &&
    bounds.top >= printArea.y &&
    bounds.bottom <=
      printArea.y + printArea.height
  );
};
const getCanvasPointerPosition = (event) => {
  const rect = designCanvas.getBoundingClientRect();

  return {
    x:
      (event.clientX - rect.left) *
      (designCanvas.width / rect.width),

    y:
      (event.clientY - rect.top) *
      (designCanvas.height / rect.height)
  };
};

const getPointerInDesignSpace = (pointer, design) => {
  const centerX = design.x + design.width / 2;
  const centerY = design.y + design.height / 2;

  const angle =
    -((design.rotation || 0) * Math.PI) / 180;

  const dx = pointer.x - centerX;
  const dy = pointer.y - centerY;

  return {
    x:
      centerX +
      dx * Math.cos(angle) -
      dy * Math.sin(angle),

    y:
      centerY +
      dx * Math.sin(angle) +
      dy * Math.cos(angle)
  };
};
const isPointerInsideDesign = (pointer, design) => {
  const localPointer =
    getPointerInDesignSpace(pointer, design);

  return (
    localPointer.x >= design.x &&
    localPointer.x <= design.x + design.width &&
    localPointer.y >= design.y &&
    localPointer.y <= design.y + design.height
  );
};

const getLayerAtPointer = (pointer) => {
  const viewState = getCurrentViewState();

  if (!viewState) return null;

  for (let i = viewState.layers.length - 1; i >= 0; i--) {
    const layer = viewState.layers[i];

    if (!layer) continue;

    if (isPointerInsideDesign(pointer, layer)) {
      return layer;
    }
  }

  return null;
};

const isPointerOnResizeHandle = (pointer, design) => {
  const localPointer =
    getPointerInDesignSpace(pointer, design);

  const handleSize = 18;

  const handleX =
    design.x + design.width - handleSize / 2;

  const handleY =
    design.y + design.height - handleSize / 2;

  return (
    localPointer.x >= handleX &&
    localPointer.x <= handleX + handleSize &&
    localPointer.y >= handleY &&
    localPointer.y <= handleY + handleSize
  );
};

const getDeformHandleAtPointer = (pointer, design) => {
  const localPointer =
    getPointerInDesignSpace(pointer, design);

  const hitSize = 12;

  const centerX =
    design.x + design.width / 2;

  const centerY =
    design.y + design.height / 2;

  const leftX =
    design.x;

  const rightX =
    design.x + design.width;

  const topY =
    design.y;

  const bottomY =
    design.y + design.height;

  const isOnLeft =
    localPointer.x >= leftX - hitSize / 2 &&
    localPointer.x <= leftX + hitSize / 2 &&
    localPointer.y >= centerY - hitSize / 2 &&
    localPointer.y <= centerY + hitSize / 2;

  if (isOnLeft) {
    return 'left';
  }

  const isOnRight =
    localPointer.x >= rightX - hitSize / 2 &&
    localPointer.x <= rightX + hitSize / 2 &&
    localPointer.y >= centerY - hitSize / 2 &&
    localPointer.y <= centerY + hitSize / 2;

  if (isOnRight) {
    return 'right';
  }

  const isOnTop =
    localPointer.x >= centerX - hitSize / 2 &&
    localPointer.x <= centerX + hitSize / 2 &&
    localPointer.y >= topY - hitSize / 2 &&
    localPointer.y <= topY + hitSize / 2;

  if (isOnTop) {
    return 'top';
  }

  const isOnBottom =
    localPointer.x >= centerX - hitSize / 2 &&
    localPointer.x <= centerX + hitSize / 2 &&
    localPointer.y >= bottomY - hitSize / 2 &&
    localPointer.y <= bottomY + hitSize / 2;

  if (isOnBottom) {
    return 'bottom';
  }

  return null;
};

const isPointerOnRotationHandle = (pointer, design) => {
  const localPointer =
    getPointerInDesignSpace(pointer, design);

  const handleSize = 18;

  const handleX =
    design.x + design.width - handleSize / 2;

  const handleY =
    design.y - handleSize / 2;

  return (
    localPointer.x >= handleX &&
    localPointer.x <= handleX + handleSize &&
    localPointer.y >= handleY &&
    localPointer.y <= handleY + handleSize
  );
};

if (designCanvas) {
  designCanvas.addEventListener('pointerdown', (event) => {
    let design = getCurrentDesign();

const pointer = getCanvasPointerPosition(event);

/* =========================================
   PRIORIDAD DE CONTROLES DE LA CAPA ACTIVA
   ========================================= */

let isOnActiveControl = false;

if (design) {
  const isOnRotation =
    isPointerOnRotationHandle(pointer, design);

  const isOnResize =
    isPointerOnResizeHandle(pointer, design);

  const deformHandle =
    getDeformHandleAtPointer(pointer, design);

  const currentLocalPointer =
    getPointerInDesignSpace(pointer, design);

  const currentDeleteSize = 18;

  const currentDeleteX =
    design.x - currentDeleteSize / 2;

  const currentDeleteY =
    design.y - currentDeleteSize / 2;

  const isOnDelete =
    currentLocalPointer.x >= currentDeleteX &&
    currentLocalPointer.x <= currentDeleteX + currentDeleteSize &&
    currentLocalPointer.y >= currentDeleteY &&
    currentLocalPointer.y <= currentDeleteY + currentDeleteSize;

  isOnActiveControl =
    isOnRotation ||
    isOnResize ||
    deformHandle !== null ||
    isOnDelete;
}

/* Solo intentamos cambiar de capa si NO estamos
   usando un control de la capa seleccionada */

const clickedLayer = !isOnActiveControl
  ? getLayerAtPointer(pointer)
  : null;

const viewState = getCurrentViewState();

/* CLIC EN ZONA VACÍA = DESELECCIONAR */
if (!isOnActiveControl && !clickedLayer) {
  if (viewState?.selectedLayerId) {
    viewState.selectedLayerId = null;

renderLayersPanel();
renderDesign();
  }

  return;
}

/* CLIC EN OTRA CAPA = SELECCIONARLA */
if (
  clickedLayer &&
  clickedLayer.id !== design?.id
) {
  if (viewState) {
    viewState.selectedLayerId = clickedLayer.id;
design = clickedLayer;

renderLayersPanel();
renderDesign();
  }
}

if (!design) return;
    
if (isPointerOnRotationHandle(pointer, design)) {
  saveHistoryState();

  isRotatingDesign = true;

  const centerX =
    design.x + design.width / 2;

  const centerY =
    design.y + design.height / 2;

  rotationStartAngle =
    Math.atan2(
      pointer.y - centerY,
      pointer.x - centerX
    );

  rotationStartValue =
    design.rotation || 0;

  designCanvas.setPointerCapture(event.pointerId);
  designCanvas.style.cursor = 'grabbing';

  return;
}

const deleteSize = 18;

const localPointer =
  getPointerInDesignSpace(pointer, design);

const deleteX =
  design.x - deleteSize / 2;

const deleteY =
  design.y - deleteSize / 2;

const isPointerOnDelete =
  localPointer.x >= deleteX &&
  localPointer.x <= deleteX + deleteSize &&
  localPointer.y >= deleteY &&
  localPointer.y <= deleteY + deleteSize;

if (isPointerOnDelete) {
  saveHistoryState();

  const viewState = getCurrentViewState();

  if (!viewState) return;

  viewState.layers = viewState.layers.filter(
    (layer) => layer.id !== design.id
  );

  viewState.selectedLayerId =
    viewState.layers[0]?.id || null;

  renderDesign();

  return;
}

/* DEFORMAR ANCHO */
activeDeformHandle =
  getDeformHandleAtPointer(pointer, design);

if (
  activeDeformHandle === 'left' ||
  activeDeformHandle === 'right' ||
  activeDeformHandle === 'top' ||
  activeDeformHandle === 'bottom'
) {
  saveHistoryState();

  deformStartWidth = design.width;
  deformStartX = design.x;
  deformStartHeight = design.height;
deformStartY = design.y;

  deformStartCenterX =
    design.x + design.width / 2;

  deformStartCenterY =
    design.y + design.height / 2;

  deformStartPointerX = pointer.x;
  deformStartPointerY = pointer.y;

  designCanvas.setPointerCapture(event.pointerId);
  designCanvas.style.cursor =
  activeDeformHandle === 'left' ||
  activeDeformHandle === 'right'
    ? 'ew-resize'
    : 'ns-resize';

  return;
}

   if (isPointerOnResizeHandle(pointer, design)) {
  isResizingDesign = true;
  saveHistoryState();

  resizeStartWidth = design.width;
  resizeStartHeight = design.height;

  /* El centro permanece fijo durante todo el escalado */
  resizeCenterX =
    design.x + design.width / 2;

  resizeCenterY =
    design.y + design.height / 2;

  /*
   * Guardamos el vector exacto desde el centro
   * hasta el punto donde hemos pulsado.
   * Así no hay salto inicial.
   */
  resizeStartVectorX =
    pointer.x - resizeCenterX;

  resizeStartVectorY =
    pointer.y - resizeCenterY;

  resizeStartVectorLengthSquared =
    Math.max(
      1,
      resizeStartVectorX * resizeStartVectorX +
      resizeStartVectorY * resizeStartVectorY
    );

  designCanvas.setPointerCapture(event.pointerId);
  designCanvas.style.cursor = 'nwse-resize';

  return;
}

    if (!isPointerInsideDesign(pointer, design)) return;

saveHistoryState();

    isDraggingDesign = true;

    dragOffsetX = pointer.x - design.x;
    dragOffsetY = pointer.y - design.y;

    designCanvas.setPointerCapture(event.pointerId);
    designCanvas.style.cursor = 'grabbing';
  });

  designCanvas.addEventListener('pointermove', (event) => {
  const design = getCurrentDesign();

  if (!design) return;

  const pointer = getCanvasPointerPosition(event);
  const printArea = getPrintArea();


/* DEFORMAR LIBRE */
if (
  activeDeformHandle === 'left' ||
  activeDeformHandle === 'right' ||
  activeDeformHandle === 'top' ||
  activeDeformHandle === 'bottom'
) {
  const angle =
    (design.rotation || 0) * Math.PI / 180;

  const axisX = Math.cos(angle);
  const axisY = Math.sin(angle);
  const verticalAxisX = -Math.sin(angle);
const verticalAxisY = Math.cos(angle);

  const pointerDeltaX =
    pointer.x - deformStartPointerX;

  const pointerDeltaY =
    pointer.y - deformStartPointerY;

  const projectedDelta =
    pointerDeltaX * axisX +
    pointerDeltaY * axisY;
    const projectedVerticalDelta =
  pointerDeltaX * verticalAxisX +
  pointerDeltaY * verticalAxisY;

  if (
  activeDeformHandle === 'left' ||
  activeDeformHandle === 'right'
) {
  const direction =
    activeDeformHandle === 'right' ? 1 : -1;

  const rawWidth =
    deformStartWidth + projectedDelta * direction;

  const newWidth =
    Math.max(
      MIN_DESIGN_SIZE,
      rawWidth
    );

  const widthDelta =
    newWidth - deformStartWidth;

  const centerShift =
    widthDelta / 2 * direction;

  const newCenterX =
    deformStartCenterX +
    axisX * centerShift;

  const newCenterY =
    deformStartCenterY +
    axisY * centerShift;

  design.width = newWidth;

  design.x =
    newCenterX - newWidth / 2;

  design.y =
    newCenterY - design.height / 2;
    }

    if (
  activeDeformHandle === 'top' ||
  activeDeformHandle === 'bottom'
) {
  const direction =
    activeDeformHandle === 'bottom' ? 1 : -1;

  const rawHeight =
    deformStartHeight +
    projectedVerticalDelta * direction;

  const newHeight =
    Math.max(
      MIN_DESIGN_SIZE,
      rawHeight
    );

  const heightDelta =
    newHeight - deformStartHeight;

  const centerShift =
    heightDelta / 2 * direction;

  const newCenterX =
    deformStartCenterX +
    verticalAxisX * centerShift;

  const newCenterY =
    deformStartCenterY +
    verticalAxisY * centerShift;

  design.height = newHeight;

  design.x =
    newCenterX - design.width / 2;

  design.y =
    newCenterY - newHeight / 2;
}

  renderDesign();

  return;
}

  /* ROTAR */
if (isRotatingDesign) {
  const centerX =
    design.x + design.width / 2;

  const centerY =
    design.y + design.height / 2;

  const angle =
    Math.atan2(
      pointer.y - centerY,
      pointer.x - centerX
    );

  const angleDelta =
  angle - rotationStartAngle;

design.rotation =
  rotationStartValue +
  (angleDelta * 180) / Math.PI;


  renderDesign();

  return;
}

  /* REDIMENSIONAR */
if (isResizingDesign) {
  const currentVectorX =
    pointer.x - resizeCenterX;

  const currentVectorY =
    pointer.y - resizeCenterY;

  /*
   * Escala con dirección.
   *
   * A diferencia de usar Math.sqrt(distancia),
   * esta fórmula sabe si nos estamos acercando
   * o alejando del centro.
   */
  const projectedScale =
    (
      currentVectorX * resizeStartVectorX +
      currentVectorY * resizeStartVectorY
    ) /
    resizeStartVectorLengthSquared;

  const minScale =
    Math.max(
      MIN_DESIGN_SIZE / resizeStartWidth,
      MIN_DESIGN_SIZE / resizeStartHeight
    );

  const scaleFactor =
    Math.max(
      minScale,
      projectedScale
    );

  const newWidth =
    resizeStartWidth * scaleFactor;

  const newHeight =
    resizeStartHeight * scaleFactor;

  /* El centro NO se mueve */
  design.width = newWidth;
  design.height = newHeight;

  design.x =
    resizeCenterX - newWidth / 2;

  design.y =
    resizeCenterY - newHeight / 2;

  renderDesign();

  return;
}

/* MOVER */
if (isDraggingDesign) {
  design.x =
    pointer.x - dragOffsetX;

  design.y =
    pointer.y - dragOffsetY;

  renderDesign();

  return;
}

const getResizeCursor = (rotation = 0) => {
  const normalized =
    ((rotation % 180) + 180) % 180;

  if (normalized >= 22.5 && normalized < 67.5) {
    return 'nesw-resize';
  }

  if (normalized >= 67.5 && normalized < 112.5) {
    return 'nwse-resize';
  }

  if (normalized >= 112.5 && normalized < 157.5) {
    return 'nesw-resize';
  }

  return 'nwse-resize';
};
 /* CURSOR */
const deformHandle =
  getDeformHandleAtPointer(pointer, design);

if (isPointerOnRotationHandle(pointer, design)) {
  designCanvas.style.cursor = 'grab';

} else if (
  deformHandle === 'left' ||
  deformHandle === 'right'
) {
  designCanvas.style.cursor = 'ew-resize';

} else if (
  deformHandle === 'top' ||
  deformHandle === 'bottom'
) {
  designCanvas.style.cursor = 'ns-resize';

} else if (isPointerOnResizeHandle(pointer, design)) {
  designCanvas.style.cursor =
    getResizeCursor((design.rotation || 0) + 45);

} else if (isPointerInsideDesign(pointer, design)) {
  designCanvas.style.cursor = 'grab';

} else {
  designCanvas.style.cursor = 'default';
}
});

  const stopDesignInteraction = (event) => {
    isDraggingDesign = false;
    isResizingDesign = false;
    isRotatingDesign = false;
    activeDeformHandle = null;

    if (designCanvas.hasPointerCapture(event.pointerId)) {
      designCanvas.releasePointerCapture(event.pointerId);
    }

    designCanvas.style.cursor = 'default';
  };

  designCanvas.addEventListener(
    'pointerup',
    stopDesignInteraction
  );

  designCanvas.addEventListener(
    'pointercancel',
    stopDesignInteraction
  );
}


  const changeProductButton = customizer.querySelector('.customizer-change-product');
  const productModal = customizer.querySelector('.customizer-product-modal');
  const closeButtons = customizer.querySelectorAll('[data-close-product-modal]');

  if (!changeProductButton || !productModal) return;

  const openModal = () => {
    productModal.hidden = false;
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    productModal.hidden = true;
    document.body.style.overflow = '';
  };

  changeProductButton.addEventListener('click', openModal);

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !productModal.hidden) {
      closeModal();
    }
  });
    /* =========================================
     CATEGORÍAS Y SELECCIÓN DE PRODUCTO
     ========================================= */

  const categoryButtons = customizer.querySelectorAll('.customizer-category');
  const productOptions = customizer.querySelectorAll('.customizer-product-option');

  const currentProductName = customizer.querySelector(
    '.customizer-product-current__info strong'
  );

  const currentProductPreview = customizer.querySelector(
    '.customizer-product-current__preview span'
  );

  const summaryRows = customizer.querySelectorAll('.customizer-summary-row');
  const summaryProduct = summaryRows[0]?.querySelector('strong');

  /* FILTRAR POR CATEGORÍA */
  categoryButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const category = button.dataset.category;

      categoryButtons.forEach((item) => {
        item.classList.remove('customizer-category--active');
      });

      button.classList.add('customizer-category--active');

      productOptions.forEach((product) => {
        const showProduct =
          category === 'all' ||
          product.dataset.category === category;

        product.hidden = !showProduct;
      });
    });
  });

  /* SELECCIONAR PRODUCTO */
  productOptions.forEach((product) => {
    product.addEventListener('click', () => {
      const productName = product.dataset.productName;
      const productType = product.dataset.productType;
      currentProductType = productType;
currentView = 'front';

      if (currentProductName) {
        currentProductName.textContent = productName;
      }

      if (currentProductPreview) {
        currentProductPreview.textContent = productType.toUpperCase();
      }

      if (summaryProduct) {
        summaryProduct.textContent = productType;
      }

      productOptions.forEach((item) => {
        item.classList.remove('customizer-product-option--selected');
      });

      product.classList.add('customizer-product-option--selected');

      viewButtons.forEach((button) => {
  button.classList.toggle(
    'customizer-view--active',
    button.dataset.view === 'front'
  );
});

updateProductPreview();

      closeModal();
    });
  });
  viewButtons.forEach((button) => {
  button.addEventListener('click', () => {
    currentView = button.dataset.view;

    viewButtons.forEach((item) => {
      item.classList.remove('customizer-view--active');
    });

    button.classList.add('customizer-view--active');

    updateProductPreview();
  });
});

updateProductPreview();
});